import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=37cad7f8&scoped=true&"
import script from "./LayoutCard.vue?vue&type=script&lang=js&"
export * from "./LayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=37cad7f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cad7f8",
  null
  
)

export default component.exports